import type { FormStep } from '@mapeamento/shared';
import { esc } from '../lib/html';
import { renderField, type FieldContext } from './fields';

const pad = (n: number) => String(n).padStart(2, '0');

export function renderStepper(
  steps: readonly FormStep[],
  current: number,
  isDone: (i: number) => boolean,
): string {
  return steps
    .map((step, i) => {
      const attrs = [
        `data-go="${i}"`,
        i === current ? 'aria-current="step"' : '',
        isDone(i) ? 'class="done"' : '',
      ].join(' ');
      return `<button type="button" ${attrs}>${step.number}<span class="nm">${esc(step.title)}</span></button>`;
    })
    .join('');
}

export function pageCounter(current: number, total: number): string {
  return `${pad(current + 1)} / ${pad(total)}`;
}

export function renderStepPanel(
  step: FormStep,
  index: number,
  total: number,
  ctx: FieldContext,
): string {
  const isLast = index === total - 1;
  const fields = step.fields
    .map((field) => renderField(field, `${step.id}.${field.id}`, ctx))
    .join('');
  return `
    <div class="ph"><span class="num">${step.number}</span><div><h2>${esc(step.title)}</h2><p>${esc(step.description)}</p></div></div>
    <div class="alert" id="alert" role="alert" hidden></div>
    ${fields}
    <div class="nav">
      <button type="button" class="btn" id="prev"${index === 0 ? ' disabled' : ''}>Voltar</button>
      <button type="button" class="btn solid" id="next">${isLast ? 'Enviar mapeamento' : 'Continuar'}</button>
    </div>`;
}

export function renderDoneScreen(args: {
  secretaria: string;
  totalFontes: number;
  protocolo: string;
}): string {
  const { secretaria, totalFontes, protocolo } = args;
  const fontes = `${totalFontes} fonte${totalFontes === 1 ? '' : 's'}`;
  return `<div class="done-card">
    <div class="ck"><svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg></div>
    <h2>Mapeamento enviado</h2>
    <p class="protocol">Protocolo <b>${esc(protocolo)}</b></p>
    <p>Recebemos o mapeamento de <b style="color:#fff">${esc(secretaria || 'sua Pasta')}</b>, com ${fontes} de conhecimento e a indicação do Ponto Focal de IA. A equipe do projeto entra em contato com o titular para os próximos passos.</p>
    <div class="acts">
      <button type="button" class="btn" id="dl">Baixar cópia (JSON)</button>
      <button type="button" class="btn" id="reset">Novo mapeamento</button>
    </div>
  </div>`;
}
